module.exports = __webpack_public_path__ + "static/media/register-bc.4f68633f.png";